import { useEffect, useState } from "react";

const useMobileDetect = (isFirstMobile: boolean = false) => {
  const [isMobile, setMobile] = useState<boolean>(isFirstMobile);

  useEffect(() => {
    if (window.innerWidth < 768 &&
      (window.screen.orientation.angle === 0 ||
        window.screen.orientation.angle === 180)) {
      setMobile(true);
    }
    
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };

    const handleOrientationChange = () => {
      const { angle } = window.screen.orientation;

      if (angle === 0 || angle === 180) {
        // 竖屏模式
        if (window.innerWidth < 768) {
          setMobile(true);
        }
      } else if (angle === 90 || angle === -90) {
        // 横屏模式
        if (window.innerWidth >= 768) {
          setMobile(false);
        }
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, [isMobile]);

  return isMobile;
};

export default useMobileDetect;
